import { render } from "./GraphVisPage.vue?vue&type=template&id=5252a296&scoped=true"
import script from "./GraphVisPage.vue?vue&type=script&lang=js"
export * from "./GraphVisPage.vue?vue&type=script&lang=js"

import "./GraphVisPage.vue?vue&type=style&index=0&id=5252a296&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5252a296"]])

export default __exports__